import styled, { css } from 'styled-components';

export const DetailReportContainer = styled.div`
  height: 75vh;
  margin-top: 20px;
  padding: 1rem;
  background: #ffffff;
  color: #000;
  border-radius: 10px;
  overflow-y: scroll;
  overflow-x: hidden;

  & tr, & th, & td {
    border: 1px solid #000;
  }

  & input[type=text] {
    border: 0px;
  }

  & input.inputNumber {
    width: 137px;
    text-align: center;
  }

  & input.inputText {
    width: 100%;
    height: 23px;
    padding: 0px 5px;
  }
`

export const TitleBar = styled.div`
  width: 1680px;
  text-align: center;
  background: #1b496a;
  color: #fff;
  font-size: 40px;
`

export const PeriodTitleBar = styled.div`
  margin-top: 30px;

  & > span {
    background: #d9d9d9;
  }
`

export const PeriodContent = styled.div`
  text-align: center;

  & > table {
    width: 100%;

    & td {
      width: 140px;
    }
  }
`

export const HoldingTitleBar = styled.div`
  & > span {
    background: #d9d9d9;
  }
`

export const HoldingContent = styled.div`
  display: flex;

  & > div.mainContent > table {
    & > thead > tr > th {
      background: #ececec;
      text-align: center;
      font-size: 17px;
      width: 140px;
      height: 20px;
    }

    & > tbody {
      & > tr > td {
        font-size: 14px;
        text-align: center;
      }
      & > tr:last-child > td {
        text-align: center;
      }
    }
  }

  & > div.subContent {
    margin-left: 140px;

    & > table {
      text-align: center;
      font-size: 15px;
      width: 700px;

      & > thead > tr > th {
        background: #ececec;
        height: 53px;
      }
      
      & > tbody > tr > td {
        height: 24px;
      }
    }
  }
`

export const OperationTitleBar = styled.div`
  & > span {
    background: #d9d9d9;
  }
`

export const OperationContent = styled.div`
  display: flex;

  & > div.mainContent > table {
    & > thead > tr > th {
      background: #ececec;
      text-align: center;
      font-size: 17px;
      width: 140px;
      height: 53px;
    }

    & > thead > tr > th:nth-child(2), & > thead > tr > th:nth-child(3) {
      width: 280px;
    }

    & > tbody {
      & > tr > td {
        font-size: 14px;
        text-align: center;
      }
      & > tr:last-child > td {
        text-align: center;
      }
    }
  }

  & > div.subContent {
    margin-left: 140px;

    & > table {
      text-align: center;
      font-size: 15px;
      width: 700px;

      & > thead > tr > th {
        background: #ececec;
        height: 53px;
      }
      
      & > tbody > tr > td {
        height: 24px;
      }
    }
  }
`

export const EventTitleBar = styled.div`
  & > span {
    background: #d9d9d9;
  }
`

export const EventContent = styled.div`
  display: flex;

  & > div.mainContent > table {
    & > thead > tr > th {
      background: #ececec;
      text-align: center;
      font-size: 17px;
      width: 140px;
      height: 53px;
    }

    & > tbody {
      & > tr > td {
        font-size: 14px;
        text-align: center;
      }
      & > tr:last-child > td {
        text-align: center;
      }
    }
  }

  & > div.subContent {
    margin-left: 140px;

    & > table {
      text-align: center;
      font-size: 15px;
      width: 700px;

      & > thead > tr > th {
        background: #ececec;
        height: 53px;
      }
      
      & > tbody > tr > td {
        height: 24px;
      }
    }
  }
`

export const EventContentTd = styled.td`
  ${props => 
    props.value !== 0 && css`color: #ff0000`
  }

  & > input {
    ${props => 
      props.value !== 0 && css`color: #ff0000`
    }
  }
`

export const CalibrateTitleBar = styled.div`
  & > span {
    background: #d9d9d9;
  }
`
export const CalibrateContent = styled.div`
  display: flex;

  & > div.mainContent > table {
    & > tbody {
      & > tr > td {
        width: 140px;
        font-size: 14px;
        text-align: center;

        &:not(:first-child) {
          text-align: center;
        }
      }
    }
  }

  & > div.subContent {
    margin-left: 140px;

    & > table {
      text-align: center;
      font-size: 15px;
      width: 700px;

      & > thead > tr > th {
        background: #ececec;
      }
      
      & > tbody > tr > td {
        height: 24px;
      }
    }
  }
`